import Vue from 'vue';
import Router from 'vue-router';
import common from './common/old/public/common';
import initFn from './common/init'
import config from './config/config';
const Home = resolve => require(['./view/home/home'], resolve);
Vue.use(Router);

const routes = [{
  path: '*',
  redirect: 'wx',
  meta: {}
},
{
  name: 'login',
  component: () => import('./view/login/login'),
  meta: {
    title: '登录'
  }
},
{
  name: 'wx-confirm',
  component: () => import('./view/login/wx/wx-confirm'),
  meta: {
    title: '微信登录'
  }
},
{
  name: 'wx',
  component: () => import('./view/login/wx'),
  meta: {
    title: '微信授权'
  }
},
{
  name: 'index',
  component: Home,
  meta: {
    title: '充电',
    keepAlive: true
  }
},
{
  name: 'home',
  component: Home,
  meta: {
    title: '充电',
    keepAlive: true
  }
},
{
  name: 'home2',
  component: Home,
  meta: {
    title: '充电',
    keepAlive: true
  }
},
{
  name: 'home-input',
  component: () => import('./view/home-input/home-input'),
  meta: {
    title: '输入枪ID'
  }
},
{
  name: 'home/city',
  component: () => import('./view/home-city/home-city'),
  meta: {
    title: '选择城市'
  }
},
{
  name: 'home/home-search-sta',
  component: () => import('./view/home-search-sta/home-search-sta'),
  meta: {
    title: '搜索站点'
  }
},
{
  name: 'home/banner-details',
  component: () => import('./view/home-banner-details/home-banner-details'),
  meta: {
    title: '搜索站点'
  }
},
{
  name: 'my',
  component: () => import('./view/my/my'),
  meta: {
    title: '我的'
  }
},
{
  name: 'my/order',
  component: () => import('./view/my-order/my-order'),
  meta: {
    title: '我的订单'
  }
},
{
  name: 'my/order/details',
  component: () => import('./view/my-order-details/my-order-details'),
  meta: {
    title: '订单详情'
  }
},
{
  name: 'my/collection',
  component: () => import('./view/my-collection/my-collection'),
  meta: {
    title: '我的收藏'
  }
},
{
  name: 'my/enterprise-member',
  component: () => import('./view/my-enterprise-member/my-enterprise-member'),
  meta: {
    title: '企业会员'
  }
},
{
  name: 'charge/ready',
  component: () => import('./view/charge/ready'),
  meta: {
    title: '准备充电'
  }
},
{
  name: 'charge/launching',
  component: () => import('./view/charge/launching'),
  meta: {
    title: '启动中'
  }
},
{
  name: 'charge/finish',
  component: () => import('./view/charge/finish'),
  meta: {
    title: '充电完成'
  }
},
{
  name: 'charge/delayed-details',
  component: () => import('./view/charge/delayed-details/delayed-details'),
  meta: {
    title: '延时费详情'
  }
},
{
  name: 'charge/sco-tips',
  component: () => import('./view/charge/sco-tips/sco-tips'),
  meta: {
    title: '充电提示'
  }
},
{
  name: 'charge/upload',
  component: () => import('./view/charge/upload'),
  meta: {
    title: '订单上传'
  }
},
{
  name: 'charge/charging',
  component: () => import('./view/charge/charging/index'),
  meta: {
    title: '正在充电'
  }
},
{
  name: 'charge/success',
  component: () => import('./view/charge-success/charge-success'),
  meta: {
    title: '充电完成'
  }
},
{
  name: 'charging/success/price',
  component: () => import('./view/charge-price-info/charge-price-info'),
  meta: {
    title: '电价信息'
  }
},
{
  name: 'station-detail',
  component: () => import('./view/station-details/station-details'),
  meta: {
    title: '电站详情'
  }
},
{
  name: 'station-fee-details',
  component: () => import('./view/station-fee-details/station-fee-details'),
  meta: {
    title: '电站费率'
  }
},
{
  name: 'my-cash',
  component: () => import('./view/my-cash/my-cash'),
  meta: {
    title: '我的余额'
  }
},
{
  name: 'my-cash-custom',
  component: () => import('./view/my-cash-custom/my-cash-custom'),
  meta: {
    title: '自定义退款'
  }
},
{
  name: 'my-cash-custom-sub',
  component: () => import('./view/my-cash-custom-sub/my-cash-custom-sub'),
  meta: {
    title: '退款选择'
  }
},
{
  name: 'my-cash-fail',
  component: () => import('./view/my-cash-fail/my-cash-fail'),
  meta: {
    title: '退款失败'
  }
},
{
  name: 'my-cash-success',
  component: () => import('./view/my-cash-success/my-cash-success'),
  meta: {
    title: '退款成功'
  }
},
{
  name: 'my-cash-record',
  component: () => import('./view/my-cash-record/my-cash-record'),
  meta: {
    title: '退款记录'
  }
},
{
  name: 'feedback-list',
  component: () => import('./view/feedback-list/feedback-list'),
  meta: {
    title: '意见反馈列表'
  }
},
{
  name: 'feedback-details',
  component: () => import('./view/feedback-list/feedback-details'),
  meta: {
    title: '意见反馈详情'
  }
},
{
  name: 'feedback',
  component: () => import('./view/feedback/feedback'),
  meta: {
    title: '意见反馈'
  }
},
{
  name: 'recharge',
  component: () => import('./view/recharge/recharge'),
  meta: {
    title: '账户充值'
  }
},
{
  name: 'recharge-refund',
  component: () => import('./view/recharge-refund/recharge'),
  meta: {
    title: '即充即退'
  }
},
{
  name: 'switch',
  component: () => import('./view/switch/switch'),
  meta: {
    title: '转入'
  }
},
{
  name: 'money',
  component: () => import('./view/money/money'),
  meta: {
    title: '我的余额'
  }
},
{
  name: 'money/detail',
  component: () => import('./view/money-detail/money-detail'),
  meta: {
    title: '余额明细'
  }
},
{
  name: 'login/wx',
  component: () => import('./view/login/wx'),
  meta: {
    title: '微信登录'
  }
},
{
  name: 'login/bind',
  component: () => import('./view/login/bind'),
  meta: {
    title: '绑定手机号'
  }
},
{
  name: 'about',
  component: () => import('./view/about/about'),
  meta: {
    title: '关于我们'
  }
},
{
  name: 'userinfo',
  component: () => import('./view/userinfo'),
  meta: {
    title: '个人中心'
  }
},
{
  name: 'userinfo-other',
  component: () => import('./view/userinfo-other'),
  meta: {
    title: '附加功能'
  }
},
{
  name: 'pay-success',
  component: () => import('./view/charge/pay-result/pay-success'),
  meta: {
    title: '支付结果'
  }
},
{
  name: 'account-refund',
  component: () => import('./view/account-refund/account-refund'),
  meta: {
    title: '账户退款'
  }
},
{
  name: 'order-not-pay',
  component: () => import('./view/charge/unpaid/charge-wait-pay'),
  meta: {
    title: '未支付订单'
  }
},
{
  name: 'my-license-plate-add',
  component: () => import('./view/my-license-plate-add/my-license-plate-add'),
  meta: {
    title: '我的车牌'
  }
},
{
  name: 'my-card',
  component: () => import('./view/my-card/my-card'),
  meta: {
    title: '充电卡'
  }
},
{
  name: 'my-changephone',
  component: () => import('./view/userinfo/my-changephone'),
  meta: {
    title: '个人信息'
  }
},
{
  name: 'record',
  component: () => import('./view/record'),
  meta: {
    title: ''
  }
},
{
  name: 'record/detail',
  component: () => import('./view/record/detail'),
  meta: {
    title: ''
  }
},
{
  name: 'recharge/protocol',
  component: () => import('./view/recharge/protocol'),
  meta: {
    title: '充值协议'
  }
},
{
  name: 'userinfo/card-multiple',
  component: () => import('./view/card-multiple-charge/card-multiple-charge'),
  meta: {
    title: '一号多充申请'
  }
},
{
  name: 'charge/home-order-list',
  component: () => import('./view/home-order-list/home-order-list'),
  meta: {
    title: '正在进行中订单'
  }
},
{
  name: 'car-list',
  component: () => import('./view/car-list/car-list'),
  meta: {
    title: '车牌号'
  }
},
{
  name: 'notice-content',
  component: () => import('./view/notice-content/notice-content'),
  meta: {
    title: '公告内容'
  }
},
{
  name: 'userinfo-service',
  component: () => import('./view/userinfo-service/userinfo-service'),
  meta: {
    title: '客服中心'
  }
},
{
  name: 'common-problem',
  component: () => import('./view/userinfo-service/common-problem'),
  meta: {
    title: '常见问题'
  }
},
{
  name: 'my-coupon',
  component: () => import('./view/my-coupon/my-coupon'),
  meta: {
    title: '我的优惠券'
  }
},
{
  name: 'activity-details',
  component: () => import('./view/activity-details/activity-details'),
  meta: {
    title: '活动详情'
  }
},
{
  name: 'qrcode-invite',
  component: () => import('./view/qrcode-invite/qrcode-invite'),
  meta: {
    title: '邀请二维码'
  }
},
{
  name: 'link-invite',
  component: () => import('./view/link-invite/link-invite'),
  meta: {
    title: '链接邀请'
  }
},
{
  name: 'my-invoice',
  component: () => import('./view/my-invoice/my-invoice'),
  meta: {
    title: '发票管理'
  }
},
{
  name: 'open-invoice',
  component: () => import('./view/open-invoice/open-invoice'),
  meta: {
    title: '申请开票'
  }
},
{
  name: 'open-invoice-add',
  component: () => import('./view/open-invoice-add/open-invoice-add'),
  meta: {
    title: '申请开票'
  }
},
{
  name: 'open-invoice-details',
  component: () => import('./view/open-invoice-details/open-invoice-details'),
  meta: {
    title: '申请开票'
  }
},
{
  name: 'open-invoice-order',
  component: () => import('./view/open-invoice-order/open-invoice-order'),
  meta: {
    title: '申请开票'
  }
},
{
  name: 'money-tips',
  component: () => import('./view/money-tips/money-tips'),
  meta: {
    title: '金额说明'
  }
},
{
  name: 'my-coupon-third',
  component: () => import('./view/my-coupon-third/my-coupon-third'),
  meta: {
    title: '第三方优惠券'
  }
},
{
  name: 'my-register',
  component: () => import('./view/my-register/my-register'),
  meta: {
    title: '签到'
  }
},
{
  name: 'my-integral-info',
  component: () => import('./view/my-integral-info/my-integral-info'),
  meta: {
    title: '积分信息'
  }
},
{
  name: 'my-integral-record',
  component: () => import('./view/my-integral-record/my-integral-record'),
  meta: {
    title: '积分成长明细'
  }
},
{
  name: 'my-integral-record/details',
  component: () => import('./view/my-integral-record-details/my-integral-record-details'),
  meta: {
    title: '积分成长明细详情'
  }
},
{
  name: 'my-exchange-record',
  component: () => import('./view/my-integral-record/my-integral-record'),
  meta: {
    title: '积分兑换记录'
  }
},
{
  name: 'my-exchange-record/details',
  component: () => import('./view/my-integral-record-details/my-integral-record-details'),
  meta: {
    title: '积分兑换记录详情'
  }
},
{
  name: 'my-exchange',
  component: () => import('./view/my-exchange/my-exchange'),
  meta: {
    title: '积分兑换'
  }
},
{
  name: 'my-member-upgrade',
  component: () => import('./view/my-member-upgrade/my-member-upgrade'),
  meta: {
    title: '会员升级'
  }
},
{
  name: 'my-member',
  component: () => import('./view/my-member/my-member'),
  meta: {
    title: '会员等级购买'
  }
},
{
  name: 'purchase-records',
  component: () => import('./view/purchase-records/purchase-records'),
  meta: {
    title: '购买记录'
  }
},
{
  name: 'purchase-records-details',
  component: () => import('./view/purchase-records-details/purchase-records-details'),
  meta: {
    title: '购买记录详情'
  }
},
{
  name: 'points-mall',
  component: () => import('./view/points-mall/points-mall'),
  meta: {
    title: '积分商城'
  }
},
{
  name: 'points-goods-details',
  component: () => import('./view/points-goods-details/points-goods-details'),
  meta: {
    title: '商品详情'
  }
},
{
  name: 'points-goods-order-sub',
  component: () => import('./view/points-goods-order-sub/points-goods-order-sub'),
  meta: {
    title: '提交订单'
  }
},
{
  name: 'points-order',
  component: () => import('./view/points-order/points-order'),
  meta: {
    title: '商城订单'
  }
},
{
  name: 'points-order-details',
  component: () => import('./view/points-order-details/points-order-details'),
  meta: {
    title: '订单详情'
  }
},
{
  name: 'points-address',
  component: () => import('./view/points-address/points-address'),
  meta: {
    title: '收货地址'
  }
},
{
  name: 'points-address-add',
  component: () => import('./view/points-address-add/points-address-add'),
  meta: {
    title: '收货地址'
  }
},
{
  name: 'points-address-oper',
  component: () => import('./view/points-address-oper/points-address-oper'),
  meta: {
    title: '自提地址'
  }
},
{
  name: 'business-consulting',
  component: () => import('./view/business-consulting/business-consulting'),
  meta: {
    title: '业务咨询'
  }
},
{
  name: 'business-consulting-add',
  component: () => import('./view/business-consulting-add/business-consulting-add'),
  meta: {
    title: '新增业务咨询'
  }
},
{
  name: 'member-companies',
  component: () => import('./view/member-companies/member-companies'),
  meta: {
    title: '企业会员申请列表'
  }
},
{
  name: 'member-companies-add',
  component: () => import('./view/member-companies-add/member-companies-add'),
  meta: {
    title: '企业会员申请'
  }
},
{
  name: 'my/charge-card',
  component: () => import('./view/charge-card/charge-card'),
  meta: {
    title: '关联电卡'
  }
},
{
  name: 'my/set-up',
  component: () => import('./view/set-up/set-up'),
  meta: {
    title: '设置'
  }
},
{
  name: 'my/service-center',
  component: () => import('./view/service-center/service-center'),
  meta: {
    title: '客服中心'
  }
},
{
  name: 'my/my-statistics',
  component: () => import('./view/my-statistics/my-statistics'),
  meta: {
    title: '统计'
  }
}
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
  if (route.name !== 'login' && route.name !== 'wx' && route.name !== 'wx-confirm' && route.name !== 'login/bind') {
    route.meta.login = true;
  }
});

const router = new Router({
  routes
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }

  if (to.name === 'login') {
    common.remove(config.localKeyLogin.homeShowListStatus);
  }
  if (!initFn.isInit) {
    initFn.init(next, to);
  } else {
    //没有登录跳转到登录界面
    let isLogin = common.get('token');
    if (!isLogin && to.meta.login && process.env.NODE_ENV === 'production') {
      console.log('no login goto login page');
      if (common.isEmpty(to.query.oprPkId)) {
        //如果没有参数，就去本地找
        to.query.oprPkId = common.get('oprPkId');
      }
      next({
        name: 'login',
        query: to.query,
      })
    } else {

      // let name = to.name;
      let query = to.query || {};
      if (!query.oprPkId) {
        let oprPkId = Vue.prototype.$oprPkId ? Vue.prototype.$oprPkId : common.get('oprPkId');
        const newTo = {
          name: to.name,
          path: to.path,
          query: Object.assign(to.query, {
            oprPkId: oprPkId
          }),
          params: to.params
        }
        if (to.query.replace) {
          newTo.replace = true
          delete to.query.replace
        }
        // query.oprPkId = oprPkId;
        next(newTo);
      } else {
        next();
      }

    }
  }
});


export {
  router
};